import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { FaPlay } from "react-icons/fa";

// MUI
import Button from "@mui/material/Button";

// Components
import Streak from "../../components/Streak";
import Topics from "../Topics";
import RoadMap from "../RoadMap";

// Styles
import styles from "./index.module.scss";

// Utils
import { courseUrl } from "../../utils/urls";

const CourseCard = ({ course, allCourses = false, latestActivity = false, archived = false, fixedWidth = false }) => {
  const { t } = useTranslation();

  const handleAddFile = useCallback(() => {
  }, []);

  const handleContinueJourney = useCallback(() => {
    if (allCourses) {
      // TODO: Implement
      return;
    }

    if (course) Turbo.visit(courseUrl(course.id));
  }, []);

  // Render
  if (!course) return null;
  const { streak, title, start_date, last_activity_date } = course;

  const renderRoadMap = () => {
    if (!latestActivity) return null;

    return (
      <div className={`${styles.roadMap}`}>
        <RoadMap courseId={course.id} reduced />
      </div>
    )
  }

  const renderActions = () => {
    if (archived) return null;

    return (
      <div className={styles.actions}>
        {!allCourses && (
          <Button
            variant="outlined"
            color="primary"
            classes={{
              root: styles.addFileButton
            }}
            onClick={handleAddFile}
          >
            {`+ ${t('courses.index.add_file')}`}
          </Button>
        )}

        {course && (
          <Button
            variant="contained"
            color="primary"
            classes={{
              root: styles.continueJourneyButton
            }}
            onClick={handleContinueJourney}
            startIcon={<FaPlay />}
          >
            {`${t('courses.index.continue_journey')}`}
          </Button>
        )}
      </div>
    )
  }

  const renderStreak = () => {
    if (!streak || streak === 0) return null;

    return <Streak streak={streak} type='badge' />
  }

  const getLastOpenedDate = () => {
    // If there's no activity date, show "never opened"
    if (!last_activity_date) {
      return t('courses.index.never_opened');
    }

    // Use last_activity_date if available, otherwise fall back to start_date
    const dateToUse = last_activity_date || start_date;
    const date = dayjs(dateToUse).format('DD/MM/YYYY');
    if (date) return date;

    return dayjs().format('DD/MM/YYYY');
  }

  let textStyle = 'text-black dark:text-white';
  let secondaryTextStyle = 'text-gray-500 dark:text-gray-400';

  return (
    <div className={`${styles.courseCard} border-2 border-gray-200 rounded-lg p-4 ${fixedWidth ? styles.fixedWidth : ''}`}>
      {renderRoadMap()}

      <div className={`${styles.courseInfo}`}>
        <div className={`${styles.topContainer}`}>
          <div className={`${styles.courseHeader}`}>
            <p className={`${styles.courseIcon}`} dir="auto">
              🎨 {course.title}
            </p>

            <div>
              {renderStreak()}
            </div>
          </div>

          <h1 className={`${styles.courseTitle} ${textStyle}`} dir="auto">
            {title}
          </h1>

          <p className={`${styles.courseDescription} ${secondaryTextStyle}`}>
            {t('courses.index.last_opened', { date: getLastOpenedDate() })}
          </p>

          {/* <Topics topics={{ current: Math.floor(Math.random() * 10), total: 10 }} isShow /> */}
        </div>

        {renderActions()}
      </div>
    </div>
  )
}

export default CourseCard;
